import React from 'react'

import { Link } from 'gatsby'

import { MegaMenuItemType } from '@contracts/wp/megaMenu'

import * as styles from './MegaMenuItem.module.scss'

type Props = {
	data: MegaMenuItemType
	className?: string
}

const MegaMenuItem: React.FC<Props> = ({ data, className }) => {
	const { label, link } = data

	const linkStyles = [styles.megaMenuItem]

	if (className) {
		linkStyles.push(className)
	}

	return (
		<Link to={link.uri || `/${link.slug}`} className={linkStyles.join(' ')}>
			{label || link.title}
		</Link>
	)
}

export default MegaMenuItem
